import { css } from '@emotion/react';
import { t } from 'i18n';
import { FlightTimeProps } from 'models';

import { getFlightTimeDateAndDuration } from '../utils';

import { getDayDifference } from './flights';
import { theme } from './theme';

const time = css`
  color: ${theme.colors.gray[3]};
  background-color: transparent;
  padding: 0;
  border-radius: ${theme.borders.radius.sm};
`;

interface FlightDateAndTimeWithDurationProps extends FlightTimeProps {
  shouldShowStops?: boolean;
}

export const FlightDateAndTimeWithDuration = (props: FlightDateAndTimeWithDurationProps) => {
  const { arrivalTime, departureTime, flightDepartureDate, flightStops, hours, minutes } =
    getFlightTimeDateAndDuration(props);
  const dayDifference = getDayDifference(props.departureTimeLocal, props.arrivalTimeLocal);
  const shouldShowStops = props.flightSegments > 1;

  const renderFlightStops = () => {
    if (shouldShowStops) {
      return (
        <>
          <span css={time}>
            ({flightStops}, {t('formattedTime', { hours, minutes })})
          </span>
        </>
      );
    } else {
      return <span css={time}>({t('formattedTime', { hours, minutes })})</span>;
    }
  };
  return (
    <>
      <span>{flightDepartureDate}</span>{' '}
      <span>
        {departureTime} - {arrivalTime}
        {dayDifference > 0 ? `+${dayDifference}` : ''} {renderFlightStops()}
      </span>
    </>
  );
};
